import React from "react";
import ContactForm from "./ContactForm";

const Conatct = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};

export default Conatct;
